
import { defineComponent, onMounted, reactive } from "vue";
import Ranking from "@/components/presentational/event/Ranking.vue";
import { RankingUserInfo } from "@/entities/ranking";
import { useRepositories } from "@/infra/api/injects";
import { Event } from "@/entities/event";

export default defineComponent({
  name: "SapporoCollectionSimpleScreen",
  components: {
    Ranking,
  },
  setup() {
    const state = reactive({
      event: {} as Event,
      ranking: [] as Array<RankingUserInfo>,
    });

    const repositories = useRepositories();
    const event_parameter = "2604_sapporo_collection";

    async function getEvent(): Promise<Event> {
      try {
        return await repositories.value.EventRepository.getEvent(event_parameter);
      } catch (e) {
        throw e;
      }
    }

    async function getEventRanking(eventID: number): Promise<Array<RankingUserInfo>> {
      try {
        return await repositories.value.EventRepository.getEventRanking(eventID);
      } catch (e) {
        return [];
      }
    }

    onMounted(async () => {
      const event = await getEvent();
      const ranking = await getEventRanking(event.id);
      state.event = event;
      state.ranking = ranking;
    });

    return {
      state,
    };
  },
});
